import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  rootLoading: {
    justifyContent: 'center',
  },
  card: {
    width: 443,
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100% - 30px)',
    },
  },
  content: {
    // display: 'flex',
    // flexDirection: 'column',
    // justifyContent: 'space-around',
  },
  logo: {
    marginTop: 50,
    // marginBottom: 20,
  },
  logoImg: {
    width: 250,
  },
}));

const Login = (props) => {
  const { children } = props;
  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      <div className={classes.logo}>
        <Fade in timeout={2000}>
          <img src="/logo.svg" alt="logo" className={classes.logoImg} />
        </Fade>
      </div>
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          {children}
        </CardContent>
      </Card>
    </div>
  );
};

Login.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Login;
